module.exports = __webpack_public_path__ + "media/images/weather/81_day-8f848662e4a4871a81dd3e5b75d91f6d.png";